/**
 * @Author: Klaudie <klaudie@foxprofi.cz>
 */

import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import type { UserProfile, Module } from '@/types/auth.types'
import { STORAGE_KEYS } from '@/lib/constants'

interface AuthState {
  user: UserProfile | null
  modules: Module[]
  isAuthenticated: boolean
  
  setUser: (user: UserProfile | null) => void
  setModules: (modules: Module[]) => void
  canAccess: (moduleSlug: string, functionSlug: string) => boolean
  login: (user: UserProfile, modules: Module[]) => void
  logout: () => void
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set, get) => ({
      user: null,
      modules: [],
      isAuthenticated: false,

      setUser: (user) => set({ user, isAuthenticated: !!user }),
      
      setModules: (modules) => set({ modules }),

      canAccess: (moduleSlug: string, functionSlug: string) => {
        const { modules } = get()
        return modules.some(
          (module) =>
            module.slug === moduleSlug &&
            module.functions.some((func) => func.slug === functionSlug)
        )
      },

      login: (user, modules) => set({ user, modules, isAuthenticated: true }),

      logout: () => set({ user: null, modules: [], isAuthenticated: false }),
    }),
    {
      name: STORAGE_KEYS.USER_PROFILE,
      partialize: (state) => ({
        user: state.user,
        modules: state.modules,
        isAuthenticated: state.isAuthenticated,
      }),
    }
  )
)
